import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import { requestSearchUsers } from 'redux/modules/users';

import { accountLoginFail } from 'redux/modules/account';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

const DeliveryDialogDriverFields = ({
  onFieldFocus,
  onFieldBlur,
  formValues,
  actions,
  account,
  classes,
  ...fields
}) => {
  const driverID = get(fields, 'driverID');
  const selectedDriverName = get(fields, 'selectedDriverName');
  return (
    <Field
      id="driverName"
      name="driverName"
      label="Driver"
      component={AutosuggestField}
      placeholder="-Select-"
      fullWidth
      renderSuggestionContent={suggestion => (
        `${suggestion['First Name']} ${suggestion['Last Name']}`
      )}
      renderInputContent={suggestion => (
        `${suggestion['First Name']} ${suggestion['Last Name']}`
      )}
      getSuggestionValue={suggestion => (
        `${suggestion['First Name']} ${suggestion['Last Name']}`
      )}
      onSuggestionSelected={(suggestion) => {
        driverID.input.onChange(suggestion.ID);
        selectedDriverName.input.onChange(`${suggestion['First Name']} ${suggestion['Last Name']}`);
        return `${suggestion['First Name']} ${suggestion['Last Name']}`;
      }}
      fetchSuggestions={({ value, limit, offset }) => (
        value.length > 0
          ? requestSearchUsers({
            filters: [
              {
                name: 'Full Name',
                operation: 'startswith',
                val: value,
                case_sensitivity: false,
              },
              {
                name: 'Role',
                operation: 'eq',
                val: 'Driver',
              },
              {
                name: 'Active',
                operation: 'eq',
                val: 'true',
              },
            ],
            limit,
            offset,
          }).then(res => res.data,
            (error) => {
              if (error.data.error === 'Access Error') {
                actions.saveRecoverOrder({
                  [account.ID]: {
                    ...formValues,
                    timestamp: new Date().getTime(),
                  },
                });
                actions.accountLoginFail();
              }
              return error;
            })
          : requestSearchUsers({
            filters: [
              {
                name: 'Role',
                operation: 'eq',
                val: 'Driver',
              },
              {
                name: 'Active',
                operation: 'eq',
                val: 'true',
              },
            ],
            limit,
            offset,
          }).then(res => res.data,
            (error) => {
              if (error.data.error === 'Access Error') {
                actions.saveRecoverOrder({
                  [account.ID]: {
                    ...formValues,
                    timestamp: new Date().getTime(),
                  },
                });
                actions.accountLoginFail();
              }
              return error;
            })
      )}
    />
  );
};

DeliveryDialogDriverFields.propTypes = {
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
    saveRecoverOrder: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
};

DeliveryDialogDriverFields.defaultProps = {
  formValues: {},
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail, saveRecoverOrder }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  DeliveryDialogDriverFields,
);



// WEBPACK FOOTER //
// ./src/components/workflow/DeliveryDialog/DeliveryDialogDriverFields.js